import type { ImagePost } from "@/react/types";
import { GridPostItem } from "./GridPostItem";

interface MasonryPostItemProps {
  onPostChange: (post: ImagePost) => void;
  onPostDestroy: (postId: number) => void;
  post: ImagePost;
}
export const MasonryPostItem = ({
  post,
  onPostChange,
  onPostDestroy,
}: MasonryPostItemProps) => (
  <GridPostItem
    post={post}
    onPostChange={onPostChange}
    onPostDestroy={onPostDestroy}
    isSquareGrid={false}
  />
);
